// extracted by mini-css-extract-plugin
export default {"cardOffer":"AddProduct_cardOffer__u-4Nr","btnOffer":"AddProduct_btnOffer__ukRVz"};